const RELOAD_AT_KEY = 'chunk-reload-at'
const RELOAD_COOLDOWN = 10_000

let reloadScheduled = false
let reloadUrl: string | null = null

export const isChunkLoadError = (error: unknown) =>
  error instanceof Error &&
  /Failed to fetch dynamically imported module|Importing a module script failed|Failed to load module script|error loading dynamically imported module|Unable to preload CSS/i.test(
    error.message
  )

const readLastReloadAt = () => {
  try {
    return Number(sessionStorage.getItem(RELOAD_AT_KEY) || 0)
  } catch {
    return 0
  }
}

const writeLastReloadAt = () => {
  try {
    sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()))
  } catch {
    // sessionStorage недоступен — перезагружаемся без защиты от цикла
  }
}

/**
 * Планирует перезагрузку. `url` — куда перейти (адрес целевого маршрута),
 * без него перезагружается текущая страница. Возвращает false, если недавно уже перезагружались.
 */
export const reloadForFreshChunks = (url?: string): boolean => {
  // Роутер знает целевой маршрут и вызывается после vite:preloadError — его адрес приоритетнее
  if (url) reloadUrl = url
  if (reloadScheduled) return true
  if (Date.now() - readLastReloadAt() < RELOAD_COOLDOWN) return false

  writeLastReloadAt()
  reloadScheduled = true
  // Откладываем, чтобы успел отработать router.onError и подставить адрес целевого маршрута
  setTimeout(() => {
    if (reloadUrl) window.location.href = reloadUrl
    else window.location.reload()
  }, 0)
  return true
}

/** Ошибка уже обработана перезагрузкой — в Sentry её отправлять не нужно */
export const isHandledByChunkReload = (error: unknown) => reloadScheduled && isChunkLoadError(error)
